import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { axiosInstance } from '@/lib/api';
import { setupAuthInterceptor } from '@/features/auth/interceptors/authInterceptor';
import { setupI18n } from '@/lib/localization.ts';
import { App } from '@/App.tsx';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// Setup auth interceptor for handling 401 responses
setupAuthInterceptor(axiosInstance);

await setupI18n();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
